var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1 6.90003C7.1 4.19383 9.29381 2.00003 12 2.00003C14.7062 2.00003 16.9 4.19384 16.9 6.90003V11.1C16.9 13.8062 14.7062 16 12 16C9.29381 16 7.1 13.8062 7.1 11.1V6.90003ZM12 3.80003C10.2879 3.80003 8.9 5.18794 8.9 6.90003V11.1C8.9 12.8121 10.2879 14.2 12 14.2C13.7121 14.2 15.1 12.8121 15.1 11.1V6.90003C15.1 5.18795 13.7121 3.80003 12 3.80003Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6795 15.3499C19.9279 14.9193 19.7803 14.3689 19.3498 14.1205C18.9193 13.8721 18.3689 14.0197 18.1205 14.4502C16.8935 16.5765 14.6101 18 12 18C9.38985 18 7.10648 16.5765 5.8795 14.4502C5.63107 14.0197 5.08067 13.8721 4.65015 14.1205C4.21963 14.3689 4.07202 14.9193 4.32046 15.3499C5.71189 17.7611 8.19838 19.4608 11.1 19.7547V22.1C11.1 22.5971 11.5029 23 12 23C12.497 23 12.9 22.5971 12.9 22.1V19.7547C15.8016 19.4608 18.2881 17.7611 19.6795 15.3499Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceOutline);
export default __webpack_public_path__ + "static/media/voice_outline.79e8dd9ccbe11f436d0e82c2e6650919.svg";
export { ForwardRef as ReactComponent };